import {
  booleanAttribute,
  Component,
  computed,
  input,
  OnInit,
  effect,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { CurrencyUtil } from 'app/core/utils/currency.utils';
import { UserCoupon } from '../../dtos/user-coupon.dto';

@Component({
  selector: 'app-user-coupon-item',
  templateUrl: './user-coupon-item.component.html',
  styleUrl: './user-coupon-item.component.scss',
  host: {
    class: 'flex w-full justify-between items-center py-4',
  },
})
export class UserCouponItemComponent implements OnInit {
  coupon = input.required<UserCoupon>();
  toggleSelectCoupon = input.required<(couponSelected: UserCoupon) => void>();
  isSelected = input(false, { transform: booleanAttribute });

  couponId = computed(() => this.coupon().id);
  couponPrice = computed(() =>
    CurrencyUtil.convertToBrazilianCurrency(this.coupon().price),
  );
  couponExpireAt = computed(() => this.coupon().expireAt);
  couponCreatedAt = computed(() => this.coupon().createdAt);
  isAssigned = computed(() => this.coupon().isAssigned);
  isRedeemed = computed(() => this.coupon().isRedeemed);
  procedures = computed(() => this.coupon().procedures);
  proceduresCount = computed(() => this.coupon().procedures.length);

  selected = new FormControl(false);

  constructor() {
    effect(() => {
      this.selected.setValue(this.isSelected(), { emitEvent: false });
    });
  }

  ngOnInit(): void {
    this.selected.setValue(this.isSelected());

    this.selected.valueChanges.subscribe(() => {
      this.toggleSelectCoupon()(this.coupon());
    });
  }
}
